import { render } from "./Earners.vue?vue&type=template&id=ed7fe754&scoped=true"
import script from "./Earners.vue?vue&type=script&lang=js"
export * from "./Earners.vue?vue&type=script&lang=js"

import "./Earners.vue?vue&type=style&index=0&id=ed7fe754&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7fe754"]])

export default __exports__